import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import { deleteBlog, deleteCourseFees, deleteFacility, getBlog, getColleges, getCourseCategories, getCourseFees, getCourses, getFacilities, getUniversities, updateBlog, updateCourseFees, updateFacility } from "../../Services/HomeService";
import moment from "moment";
import HttpClientXml from "../../utils/HttpClientXml";
import Swal from "sweetalert2";
import "./Style.css"
import Select from "react-select";
import ReactQuill from "react-quill";
import { getPlainTextFromHtml } from "../../utils/Helper";

const tabNames = [
  {
    value: "Overview",
    label: "Overview"
  },
  {
    value: "Courses & Fees",
    label: "Courses & Fees"
  },

  {
    value: "Admission",
    label: "Admission"
  },
  {
    value: "Scholarship",
    label: "Scholarship"
  },
  {
    value: "Placements",
    label: "Placements"
  },
  {
    value: "CutOffs",
    label: "CutOffs"
  },
  {
    value: "Ranking",
    label: "Ranking"
  },
  {
    value: "Campus",
    label: "Campus"
  },
  {
    value: "Reviews",
    label: "Reviews"
  },
  {
    value: "Fees",
    label: "Fees"
  }
]

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const ManageFacility = () => {
  const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
  };
  const customStyles = {
    headCells: {
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        color: "#333",
      },
    },
  };



  const initialValues = {
    name: "",
    icon: ""
  }

  const fileInputRef = useRef(null);
  const [colleges, setColleges] = useState([]);
  const [fetchCollegesLoading, setFetchCollegesLoading] = useState(false);
  const [uploading, setUploading] = useState(false)

  const [updateLoading, setUpdateLoading] = useState(false);
  const [updateId, setUpdateId] = useState(null)
  const [formData, setFormData] = useState(initialValues)

  const [fetchLoading, setFetchLoading] = useState(false);
  const [allData, setAllData] = useState([])

  const fetchAllData = async () => {
    try {
      setFetchLoading(true);
      const res = await getFacilities();
      console.log("FRE124", res?.data);
      if (res?.status) {
        setAllData(res?.data);
        setFetchLoading(false);
      } else {
        toast.error("Error while Fetching Facilities");
        setFetchLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Facilities Data");
      console.error("Error fetching Facilities:", error);
      setFetchLoading(false);
    }
  };



  const fetchColleges = async () => {
    try {
      setFetchCollegesLoading(true);
      const res = await getColleges();
      console.log("fetched Colleges", res?.data);
      if (res?.status) {
        setColleges(res?.data);
        setFetchCollegesLoading(false);
      } else {
        toast.error("Error while Fetching Colleges Data");
        setFetchCollegesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Colleges Data");
      console.error("Error fetching Colleges:", error);
      setFetchCollegesLoading(false);
    }
  };





  const handleFileUpload = async (e) => {
    e.preventDefault()
    setUploading(true)
    const data = new FormData();
    data.append("image", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      console.log("KJH124", res);

      if (res?.image) {
        setFormData({ ...formData, icon: res.image })
        toast.success("Image uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    } finally {
      setUploading(false)
      fileInputRef.current.value = null;
    }
  };

  const handleEdit = (data) => {
    setUpdateId(data?._id)
    const displayData = {
      name: data?.name || "",
      icon: data?.icon || "",
    }
    setFormData(displayData)
  }

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Facility?",
      text: "Are you sure you want to delete this Facility?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        await deleteFacility(id);
        Swal.fire("Deleted!", "Facility has been deleted.", "success");
        fetchAllData();
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Facility.", "error");
      }
    }
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      center: true,
    },
    {
      name: "Image",
      selector: (row) => <><img src={row?.icon} style={{ maxHeight: "100px", maxWidth: "100px", margin: "5px 0" }} /></>,
      sortable: true,
      wrap: true,
    },
    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <span title="Edit">
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
              onClick={() => handleEdit(row)}
            ></i>
          </span>
          <span title="Delete">
            <i
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
              onClick={() => handleDelete(row?._id)}
            ></i>
          </span>
        </>
      ),
    },
  ];

  const handleCancel = () => {
    setUpdateId(null);
  };

  const handleUpdate = async (e) => {
    e?.preventDefault();
    console.log("KJU388", formData);
    try {
      setUpdateLoading(true);
      const res = await updateFacility(updateId, formData);
      console.log("Facility Update Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setFormData(initialValues)
        setUpdateId(null);
        setUpdateLoading(false);
      } else {
        toast.error(res?.message);
        setUpdateLoading(false);
      }
    } catch (error) {
      toast.error("Failed to update Facility.");
      console.error("Error updating Facility:", error);
      setUpdateLoading(false);
    } finally {
      fetchAllData()
    }
  };

  useEffect(() => {
    fetchAllData()
    // fetchColleges()
  }, [])

  return (
    <div>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div style={headLineStyle} className="page-headline">
            Manage Facility
          </div>
          {
            updateId ? (
              <>
                <section className="chartBox_area">
                  <form
                    onSubmit={(e) => {
                      handleUpdate(e);
                    }}
                  >
                    <div className="row d-flex justify-content-center">



                      <div className="col-md-6 mt-3">
                        <label htmlFor="Brochure">
                          {uploading && "Uploading "} Icon Photo
                        </label>
                        {!uploading && formData?.icon && (
                          <>
                            <img
                              src={formData?.icon}
                              alt="Photo Preview"
                              style={{ display: "block", margin: "10px 0", maxHeight: "100px" }}
                            />

                          </>
                        )}
                        <input
                          type="file"
                          ref={fileInputRef}
                          className="form-control"
                          onChange={handleFileUpload}
                          accept="image/*"
                        />
                      </div>


                      {/* <div className="col-md-12 mt-3">
                        <label htmlFor="longDescription">
                          Blog/News Description
                        </label>
                        <ReactQuill
                          modules={modules}
                          theme="snow"
                          value={formData?.description}
                          onChange={(value) => {
                            setFormData((prev) => ({
                              ...prev,
                              description: value,
                            }));
                          }}
                          placeholder="Enter Details"
                          style={{
                            height: "150px",
                            marginBottom: "40px",
                            fontFamily: "Poppins",
                            fontSize: "1rem"
                          }}
                        />
                      </div> */}

                      <div className="col-md-6 mt-3">
                        <label htmlFor="name">
                          Facility Name<span className="text-danger">*</span>
                        </label>
                        <input
                          value={formData?.name}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              name: e.target.value,
                            }));
                          }}
                          type="text"
                          id="name"
                          className="form-control"
                          placeholder="Enter Country Name"
                          required
                        />
                      </div>

                    </div>
                    {/* <div className=" d-flex justify-content-center">
                              <button
                                type="button"
                                className="btn mt-3"
                                style={{
                                  background: "#a2bae0",
                                  borderRadius: "13px",
                                }}
                              >
                                Add More
                              </button>
                            </div> */}
                    <div className=" d-flex justify-content-center" style={{ gap: "15px" }}>
                      <button
                        disabled={updateLoading}
                        type="submit"
                        className="btn mt-3"
                        style={{
                          background: "rgb(133, 218, 79)",
                          borderRadius: "13px",
                        }}
                      >
                        {updateLoading
                          ? "Saving data..."
                          : "Update Facility"}
                      </button>
                      <button
                        onClick={() => {
                          handleCancel();
                        }}
                        disabled={updateLoading}
                        type="button"
                        className="btn mt-3"
                        style={{
                          background: "#f77754",
                          borderRadius: "13px",
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </section>
              </>
            ) : (
              <>
                <section className="chartBox_area">
                  <DataTable
                    data={allData}
                    columns={columns}
                    pagination
                    responsive
                    highlightOnHover
                    customStyles={customStyles}
                  />
                </section>
              </>
            )
          }

        </div>
      </div>
    </div>
  );
};

export default ManageFacility;
